import {
  AppTheme,
  ThemeId,
} from '../../../../main-service/infrastructure/types/features/themes/theme-types';
import otherTheme from './other-theme/other-theme';
import defaultTheme from './default-theme/default-theme';
import beelineTheme from './beeline-theme/beeline-theme';

const themes: AppTheme[] = [defaultTheme, otherTheme, beelineTheme];

function getDefaultTheme(): AppTheme {
  return themes[0];
}

function getThemeById(id: ThemeId): AppTheme {
  return themes.find(theme => theme.id === id) || getDefaultTheme();
}

export { themes, getDefaultTheme, getThemeById };
